import connect from '../Components/StateHandler';
import React from 'react';
import i18n from '../i18n'

const tasks = [
    {
        id: 1,
        name: i18n.t('gantt:tasks.1.name'),
        author: i18n.t('gantt:tasks.1.author'),
        group: 1,
        offsetStart: 0,
        offsetEnd: 5,
        color: 'purple'
    },
    {
        id: 2,
        dependency: 1,
        name: i18n.t('gantt:tasks.2.name'),
        author: i18n.t('gantt:tasks.2.author'),
        group: 1,
        offsetStart: 5,
        offsetEnd: 8,
        color: 'blue'
    },
    {
        id: 3,
        dependency: 2,
        name: i18n.t('gantt:tasks.3.name'),
        author: i18n.t('gantt:tasks.3.author'),
        group: 1,
        offsetStart: 8,
        offsetEnd: 9,
        color: 'green'
    },
    {
        id: 5,
        name: i18n.t('gantt:tasks.4.name'),
        author: i18n.t('gantt:tasks.4.author'),
        offsetStart: 0,
        offsetEnd: 5,
        color: 'coolgreen'
    },
    {
        id: 6,
        name: i18n.t('gantt:tasks.5.name'),
        author: i18n.t('gantt:tasks.5.author'),
        dependency: 5,
        offsetStart: 7,
        offsetEnd: 9,
        color: 'purple'
    },
    {
        id: 7,
        name: i18n.t('gantt:tasks.6.name'),
        author: i18n.t('gantt:tasks.6.author'),
        dependency: 6,
        offsetStart: 9,
        offsetEnd: 11,
        color: 'green'
    }
];

const gridSizing = 25;
const scrollOffset = 100;
const moving = false;
const tooltips = [
    {
        name: 'move',
        text: i18n.t('gantt:tooltips.move')
    },
    {
        name: 'resize',
        text: i18n.t('gantt:tooltips.resize')
    }
];

const store = connect({
    tasks,
    gridSizing,
    scrollOffset,
    moving,
    tooltips
});

function TasksWrapper(InnerComponent) {
    class TasksProvider extends React.Component {
        getTaskById(id) {
            return this.props.tasks.find(task => task.id === id);
        }
        moveTask({ id, offset }) {
            const task = this.getTaskById(id);

            this.updateTask({
                id: id,
                offsetStart: task.offsetStart + offset,
                offsetEnd: task.offsetEnd + offset
            });
            this.props.setGlobalState({
                tooltips: this.props.tooltips.filter(
                    tooltip =>
                        (tooltip.name !== 'move' && tooltip.name !== 'trial')
                )
            });
            this.alignTasksBasedOnId(id);
        }
        resizeTask({ id, direction, offset }) {
            const task = this.getTaskById(id);
            const width = task.offsetEnd - task.offsetStart;
            if (direction === 'left' && (task.offsetStart + offset +1 > task.offsetEnd) && offset > 0) {
                return;
            }
            if (direction === 'right' && width + offset < 1 && offset < 0) {
                return;
            }

            this.props.setGlobalState({
                tooltips: this.props.tooltips.filter(
                    tooltip =>
                        (tooltip.name !== 'resize' && tooltip.name !== 'trial')
                )
            });
            this.updateTask({
                id: id,
                offsetStart:
                    direction === 'left'
                        ? task.offsetStart + offset
                        : task.offsetStart,
                offsetEnd:
                    direction === 'right'
                        ? task.offsetEnd + offset
                        : task.offsetEnd
            });
            this.alignTasksBasedOnId(id, true);
        }
        findDependentTask(id) {
            return this.props.tasks.find(task => task.dependency === id);
        }
        alignTasksBasedOnId(id, resize) {
            const task = this.getTaskById(id);
            const dependency = this.getTaskById(task.dependency);
            const dependent = this.findDependentTask(task.id);
            if (dependency) {
                const offset = task.offsetStart - dependency.offsetEnd;
                if (offset < 0) {
                    this.updateTask({
                        id: dependency.id,
                        offsetStart: dependency.offsetStart + offset,
                        offsetEnd: dependency.offsetEnd + offset
                    });
                    this.alignTasksBasedOnId(dependency.id, resize);
                }
            }
            if (dependent) {
                const offset = task.offsetEnd - dependent.offsetStart;
                if (offset > 0) {
                    this.updateTask({
                        id: dependent.id,
                        offsetStart: dependent.offsetStart + offset,
                        offsetEnd: dependent.offsetEnd + offset
                    });
                    this.alignTasksBasedOnId(dependent.id, resize);
                }
            } else {
                return false;
            }
        }
        updateTask(taskToUpdate) {
            let tasks = this.props.tasks;
            const index = tasks.findIndex(task => task.id === taskToUpdate.id);
            tasks[index] = Object.assign({}, tasks[index], taskToUpdate);
            this.props.setGlobalState({ tasks });
        }
        getTasks() {
            return this.props.tasks;
        }
        render() {
            return (
                <InnerComponent
                    {...this.props}
                    moveTask={this.moveTask.bind(this)}
                    resizeTask={this.resizeTask.bind(this)}
                    getTaskById={this.getTaskById.bind(this)}
                />
            );
        }
    }
    return store(TasksProvider);
}

export default TasksWrapper;
